import React from 'react';
import CountryLookup from './CountryLookup';
import StateLookup from './StateLookup';
import PayeeLookup from './PayeeLookup';
import { Grid } from '@material-ui/core';
import { CountriesWithStatesIso } from './Helpers';
import { AddNewCompany } from './Popups';

const CompanyPayee = ({
  payeeDetailsState, setPayeeDetailsState, abortController, setAbortController,
  control, forceClearDatasourceState, setForceClearDatasourceState, errors,
  getRequiredError, setBannerState, setValue, reset, resetField, setLoading }) => {
  const renderCountry = () => {
    return (
      <CountryLookup
        countryFieldName="countryOfIncorporation"
        payeeDetailsState={payeeDetailsState}
        setPayeeDetailsState={setPayeeDetailsState}
        abortController={abortController}
        setAbortController={setAbortController}
        control={control}
        forceClearDatasourceState={forceClearDatasourceState}
        setForceClearDatasourceState={setForceClearDatasourceState}
        errors={errors}
        getRequiredError={getRequiredError}
        setBannerState={setBannerState}
        setValue={setValue}
        reset={reset}
        resetField={resetField}
        setLoading={setLoading}
      />
    );
  }

  const renderState = () => {
    const render = CountriesWithStatesIso.includes(payeeDetailsState.countryOfIncorporationIso2);
    return (
      render &&
      <StateLookup
        stateFieldName="stateOfIncorporation"
        payeeDetailsState={payeeDetailsState}
        setPayeeDetailsState={setPayeeDetailsState}
        abortController={abortController}
        setAbortController={setAbortController}
        control={control}
        forceClearDatasourceState={forceClearDatasourceState}
        setForceClearDatasourceState={setForceClearDatasourceState}
        errors={errors}
        getRequiredError={getRequiredError}
        setBannerState={setBannerState}
        setValue={setValue}
        reset={reset}
        resetField={resetField}
        setLoading={setLoading}
      />
    );
  }

  const renderCompanyLookupHeader = () => {
    return ({ className }) => {
      return (
        <Grid container direction="row" spacing={0} className={className}>
          <Grid item xs={4}><div>Payee</div></Grid>
          <Grid item xs={1}><div>Country</div></Grid>
          <Grid item xs={1}><div>State</div></Grid>
          <Grid item xs={1}><div>City</div></Grid>
          <Grid item xs={3}><div>Address</div></Grid>
          <Grid item xs={1}><div>OrbisId</div></Grid>
          <Grid item xs={1}><div>Source</div></Grid>
        </Grid>
      );
    };
  }

  const renderCompanyLookupView = () => {
    return ({ option, className }) => {
      return (
        <Grid container direction="row" spacing={0} className={className}>
          <Grid item xs={4}><div>{option.organizationName}</div></Grid>
          <Grid item xs={1}><div>{option.countryOfIncorporation}</div></Grid>
          <Grid item xs={1}><div>{option.stateCode}</div></Grid>
          <Grid item xs={1}><div>{option.city}</div></Grid>
          <Grid item xs={3}><div>{`${option.address ?? ''} ${option.postcode ?? ''}`}</div></Grid>
          <Grid item xs={1}><div>{option.orbisId}</div></Grid>
          <Grid item xs={1}><div>{option.source}</div></Grid>
        </Grid>
      );
    };
  }

  const renderPayeeLookup = () => {
    return (
      <PayeeLookup
        payeeDetailsState={payeeDetailsState}
        setPayeeDetailsState={setPayeeDetailsState}
        abortController={abortController}
        setAbortController={setAbortController}
        control={control}
        forceClearDatasourceState={forceClearDatasourceState}
        setForceClearDatasourceState={setForceClearDatasourceState}
        errors={errors}
        getRequiredError={getRequiredError}
        setBannerState={setBannerState}
        setValue={setValue}
        setLoading={setLoading}
        renderLookupHeader={renderCompanyLookupHeader}
        renderLookupView={renderCompanyLookupView}
        Popup={AddNewCompany}
      />
    )
  }

  return (
    <>
      {renderCountry()}
      {renderState()}
      {renderPayeeLookup()}
    </>
  );
}

export default CompanyPayee; 